import { compareAsc, compareDesc } from "date-fns";
import type { Novel } from "@/lib/models";

/** ホーム作品一覧（NovelList）と同じソートキー */
export type NovelListSortKey = "createdAt" | "updatedAt" | "title" | "";

/** ホーム作品一覧と同じ昇順 / 降順 */
export type NovelListSortOrder = "asc" | "desc";

/**
 * ホーム作品一覧と同じ並びにする。
 * 1. sortKey があれば作成日 / 更新日 / タイトルでソート
 * 2. ピン留め作品を先頭に固定
 */
export function sortAndPinNovels(
  novels: Novel[],
  sortKey: string | null | undefined,
  sortOrder: string | null | undefined
): Novel[] {
  const result = novels.slice();

  if (sortKey) {
    const compareFn = sortOrder === "asc" ? compareAsc : compareDesc;
    const localeFn =
      sortOrder === "asc"
        ? (x: Novel, y: Novel) => x.title.localeCompare(y.title)
        : (x: Novel, y: Novel) => y.title.localeCompare(x.title);

    switch (sortKey) {
      case "createdAt":
        result.sort((x, y) => compareFn(x.createdAt!, y.createdAt!));
        break;
      case "updatedAt":
        result.sort((x, y) => compareFn(x.updatedAtLatestDataInNovel!, y.updatedAtLatestDataInNovel!));
        break;
      case "title":
        result.sort(localeFn);
        break;
      default:
        break;
    }
  }

  const pinnedNovels = result.filter((novel) => novel.pinned);
  const unpinnedNovels = result.filter((novel) => !novel.pinned);
  return [...pinnedNovels, ...unpinnedNovels];
}
